<template>
  <div>
    <b-card no-body class="mt-3">
      <b-card-body class="text-center">
        <b-card-title>Vergleichsergebnis</b-card-title>
        <b-card-sub-title class="mb-2"
          >Selbstabrechnung vs opta data Abrechnung</b-card-sub-title
        >

        <div class="d-flex justify-content-center mt-3">
          <OdilBar
            class="col-12 col-lg-6 d-flex justify-self-center"
            :chart-data="chartdata"
          />
        </div>
      </b-card-body>

      <b-table
        :items="computedItems"
        :fields="fields"
        :tbody-tr-class="rowClass"
      >
      </b-table>
    </b-card>
  </div>
</template>

<script>
import OdilBar from "@/components/OdilBar.vue";
export default {
  name: "ErgebnisCard",
  components: { OdilBar },
  data() {
    return {
      fields: ["Abrechnung", "Kosten_pro_Beleg", "Kosten_pro_Monat"]
    };
  },
  computed: {
    computedItems() {
      // if (this.$store.state.Gebuehren.useConnect) {
      //   return [
      //     {
      //       Abrechnung: "Selbstabrechnung",
      //       Kosten_pro_Beleg: this.totalBelegGesamtkosten,
      //       Kosten_pro_Monat: this.totalGesamtkosten
      //     },
      //     {
      //       Abrechnung: "opta data (classic)",
      //       Kosten_pro_Beleg: this.totalKostenOptaDataProBeleg,
      //       Kosten_pro_Monat: this.totalKostenOptaData
      //     },
      //     {
      //       Abrechnung: "Connect-Kosten",
      //       Kosten_pro_Beleg: this.totalConnectKostenBeleg,
      //       Kosten_pro_Monat: this.totalConnectKosten,
      //       status: "connect"
      //     },
      //     {
      //       Abrechnung: "Sparpotenzial (berechnet ohne Connect)",
      //       Kosten_pro_Beleg: this.ersparnisProBeleg,
      //       Kosten_pro_Monat: this.ersparnisProMonat
      //     }
      //   ];
      // } else {
      return [
        {
          Abrechnung: "Selbstabrechnung",
          Kosten_pro_Beleg: this.totalBelegGesamtkosten,
          Kosten_pro_Monat: this.totalGesamtkosten
        },
        {
          Abrechnung: "opta data (classic)",
          Kosten_pro_Beleg: this.totalKostenOptaDataProBeleg,
          Kosten_pro_Monat: this.totalKostenOptaData
        },
        {
          Abrechnung: "Sparpotenzial",
          Kosten_pro_Beleg: this.ersparnisProBeleg,
          Kosten_pro_Monat: this.ersparnisProMonat
        }
      ];
      // }
    },
    totalGesamtkosten() {
      return this.$store.getters.total.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    totalBelegGesamtkosten() {
      return this.$store.getters.totalBeleg.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    totalKostenOptaData() {
      if (
        this.$store.getters.optadataKostenProBeleg >
        this.$store.state.Gebuehren.mindestGebührBeleg
      ) {
        return this.$store.getters.optadataKosten.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR"
        });
      } else {
        return this.$store.getters.optadataKostenMindestgebühr.toLocaleString(
          "de-DE",
          {
            style: "currency",
            currency: "EUR"
          }
        );
      }
    },
    totalKostenOptaDataProBeleg() {
      return this.$store.getters.optadataKostenProBeleg.toLocaleString(
        "de-DE",
        {
          style: "currency",
          currency: "EUR"
        }
      );
    },
    ersparnisProBeleg() {
      return this.$store.getters.ersparnisProBeleg.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    ersparnisProMonat() {
      return this.$store.getters.ersparnisProMonat.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    totalConnectKosten() {
      return this.$store.getters[
        "Rezeptmanagment/totalConnectKosten"
      ].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    totalConnectKostenBeleg() {
      return this.$store.getters[
        "Rezeptmanagment/totalConnectKostenBeleg"
      ].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    },
    //Chartdaten
    chartdata() {
      return {
        labels: ["Selbstabrechnung", "optadata"],
        datasets: [
          {
            label: "Kostenvergleich pro Monat",
            backgroundColor: ["#f87979", "#58D68D"],
            data: [
              this.$store.getters.total,
              this.$store.getters.optadataKosten
            ]
          }
        ]
      };
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "connect") return "table-info";
    }
  }
};
</script>
